import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

export const ProjectIdChipStyled = styled.div`
	display: flex;
	justify-content: center;

	height: 20px;
	width: fit-content;
	min-width: 50px;
	padding: 0 8px;
	border-radius: 6px;
	flex-shrink: 0;
	font-size: 10px;
	font-weight: 500;
	line-height: 20px;
	margin-right: 16px;
	color: ${props => (props.useDarkText ? CSS_CONSTANTS['$v2-text-gray'] : 'white')};
	background-color: ${props => props.projectColor};
`;

export const ProjectBadgeStyled = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 10px;
	margin-right: 12px;
`;
